import { ChangeDetectionStrategy, Component } from "@angular/core";
import { EventContentDto, UserDto } from "@api";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { AppRoutes, EVENT_CONTENTS_PER_PAGE } from "src/app/constants";
import { RootState } from "src/app/store";
import * as EventActions from "src/app/store/event/actions";
import * as FromUser from "src/app/store/user/selectors";
import * as FromEvent from "src/app/store/event/selectors";
import { AlertController, IonRouterOutlet, ModalController, NavController, PopoverController } from "@ionic/angular";
import { FormControl, FormGroup } from "@angular/forms";
import { EventPage } from "src/app/modals/event/event.page";
import { PopoverButton, PopoverComponent } from "src/app/components/popover/popover.component";

@Component({
  selector: "app-event-contents",
  templateUrl: "./event-contents.page.html",
  styleUrls: ["./event-contents.page.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventContentsPage {
  public routes: typeof AppRoutes = AppRoutes;
  public form: FormGroup;
  public user$: Observable<UserDto> = this.store.select(FromUser.selectUser);
  public eventContents$: Observable<EventContentDto[]> = this.store.select(FromEvent.selectAllContents);
  public currentPage$: Observable<number> = this.store.select(FromEvent.selectCurrentPage);
  public totalPages$: Observable<number> = this.store.select(FromEvent.selectTotalPages);
  public breadcrumbs = [{ name: "Dashboard", link: `/${this.routes.home}` }, { name: "Veranstaltungen verwalten" }];

  constructor(
    private store: Store<RootState>,
    private routerOutlet: IonRouterOutlet,
    private alertController: AlertController,
    private modalController: ModalController,
    private popoverController: PopoverController,
    private navController: NavController,
  ) {
    this.form = new FormGroup({
      search: new FormControl(),
    });
  }

  public trackBy(_: number, content: EventContentDto): string {
    return content.id;
  }

  public async presentPopover(event: Event): Promise<void> {
    const buttons: PopoverButton[] = [
      {
        text: "Veranstaltung erstellen",
        handler: (): Promise<boolean> => this.navController.navigateForward([AppRoutes.eventContents, AppRoutes.add]),
      },
    ];
    const popover = await this.popoverController.create({
      component: PopoverComponent,
      componentProps: { buttons },
      event,
    });

    await popover.present();
  }

  public async handleContentClick(content: EventContentDto): Promise<void> {
    const modal = await this.modalController.create({
      component: EventPage,
      componentProps: { content },
      presentingElement: this.routerOutlet.nativeEl,
      cssClass: ["event-detail-modal"],
      swipeToClose: true,
    });

    await modal.present();
  }

  public async handleContentDelete(nativeEvent: Event, event: EventContentDto): Promise<void> {
    nativeEvent.stopPropagation();
    const alert = await this.alertController.create({
      header: "Ereignis löschen",
      message: "Bestätigen Sie, dass Sie dieses Ereignis löschen möchten?",
      buttons: [
        { text: "Abbrechen", role: "cancel" },
        { text: "Ja, löschen", handler: (): void => this.store.dispatch(EventActions.removeEvent({ eventId: event.id })) },
      ],
      backdropDismiss: false,
    });

    await alert.present();
  }

  protected ionViewDidEnter(): void {
    this.store.dispatch(EventActions.getEventContents({ limit: EVENT_CONTENTS_PER_PAGE, page: 1 }));
  }
}
